import { render, staticRenderFns } from "./ButtonScrollInPageTop.vue?vue&type=template&id=4e64d05c&"
import script from "./ButtonScrollInPageTop.vue?vue&type=script&lang=js&"
export * from "./ButtonScrollInPageTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports